import React from 'react'
import { FormattedHTMLMessage } from '@web/walter-ui-kit'

import { lang } from './lang'
import styles from './style.module.css'

interface Props {
    message: string
}

/**
 * Tx notification public message (comment) component
 */
export function TxPublicMessage({ message }: Props) {
    return (
        <div className={styles.wrapper}>
            <FormattedHTMLMessage {...lang.messageTitle} tagName="p" className={styles.title} />
            <div className={styles.message}>{message}</div>
        </div>
    )
}

export default TxPublicMessage
